module.exports = __webpack_public_path__ + "static/second-75e349d354eb283fbcf11c9122d1b31a.jpg";